module.exports = "/_next/static/images/vidaProduto-cecee3988d35835607ca9c152c5f0216.svg";